<template>
    <div class="position-relative" v-loading="loading">
        <ux-grid
            ref="plxTable"
            stripe
            show-overflow
            use-virtual
            :data = "data"
            :highlightCurrentRow="true"
            @selection-change="selectionChange"
            :empty-text = "emptyTxt"
            :checkboxConfig="{highlight: true}"
            :edit-config="{trigger: 'click', mode: 'cell'}">
            <ux-table-column type="checkbox" :width="40"/>
            <ux-table-column field="index" title="index" :width="40" edit-render>
                <template v-slot:edit="scope">
                    <el-input v-model="scope.row.index"></el-input>
                </template>
            </ux-table-column>
            <ux-table-column field="id" title="id" :width="50"></ux-table-column>
            <ux-table-column field="lid" title="lid" :width="50"></ux-table-column>
            <ux-table-column field="league" title="联赛" :width="80" :filters="filters" :filter-method="filterLeague"></ux-table-column>
            <ux-table-column field="color" title="颜色" :width="50"></ux-table-column>
            <ux-table-column title="日期" field="date" :width="60"></ux-table-column>
            <ux-table-column title="时间" field="time" :width="60"></ux-table-column>
            <ux-table-column title="主队" field="home"></ux-table-column>
            <ux-table-column title="客队" field="away"></ux-table-column>
            <ux-table-column title="主排名" field="home_rank" :width="50"></ux-table-column>
            <ux-table-column title="客排名" field="away_rank" :width="50"></ux-table-column>
            <ux-table-column title="让球" field="handicap" :width="50"></ux-table-column>
            <ux-table-column title="主水" field="h_index" :width="50"></ux-table-column>
            <ux-table-column title="客水" field="a_index" :width="50"></ux-table-column>
            <ux-table-column title="总分" field="bigsmall" :width="50"></ux-table-column>
            <ux-table-column title="大" field="big" :width="50"></ux-table-column>
            <ux-table-column title="小" field="small" :width="50"></ux-table-column>
            <ux-table-column title="hxg" field="hxg" :width="60" edit-render>
                <template v-slot:edit="scope">
                    <el-input v-model="scope.row.hxg"></el-input>
                </template>
            </ux-table-column>
            <ux-table-column title="axg" field="axg" :width="60" edit-render>
                <template v-slot:edit="scope">
                    <el-input v-model="scope.row.axg"></el-input>
                </template>
                </ux-table-column>
            <ux-table-column title="hfa" field="hfa" :width="50"></ux-table-column>
            <ux-table-column title="qsda" field="qsda" :width="60" edit-render>
                <template v-slot:edit="scope">
                    <el-input v-model="scope.row.qsda"></el-input>
                </template>
            </ux-table-column>
        </ux-grid>
        <!-- <div class="bottom-btn w-100 text-end py-2">
            <el-button @click="saveChange">保存修改</el-button>
        </div> -->
    </div>
</template>

<script>
import { searchLgByCnameUrl, createLeagueUrl, updateLeagueUrl } from '../../constants/http.config'
export default {
    props: {
        matchdata: {
            type: Array,
            default: ()=>[]
        },
        emptyText: {
            type: String,
        },
        reload: {
            type: Boolean,
            default: ()=>false
        },
    },
    data(){
        return {
            data: [],
            filters: [],
            countries: [],
            loading: false,
            emptyTxt: '',
            columns: [
                { label: 'id', prop: 'id'},
                { label: 'lid', prop: 'lid'},
                { label: '颜色', prop: 'color'},
                { label: '联赛', prop: 'name'},
                { label: "日期", prop: "date"},
                { label: "时间", prop: "time"},
                { label: "主队", prop: "home"},
                { label: "客队",  prop: "away"},
                { label: "主排名", prop: "homeRank"},
                { label: "客排名", prop: "awayRank"},
                { label: "让球", prop: "handicap"},
                { title: "主水" , prop: "hindex"},
                { label: "客水", prop: "aindex"},
                { label: "总分", prop: "bigsmall"},
                { label: "大", prop: "big"},
                { label: "小", prop: "small"},
                { abel: "qsda", prop: "qsda"},
            ],
        }
    },
    mounted() {
        this.data = this.matchdata;
        this.emptyTxt = this.emptyText;
        console.log('mounted: matchdata.length', (this.matchdata || []).length, 'sample', (this.matchdata || []).slice(0,3));
        console.log('mounted before updateFilters filters:', this.filters);
        this.updateFilters();
        console.log('mounted after updateFilters filters:', this.filters);
    },
    watch:{
        reload: {
            handler(newVal, oldVal) {
                console.log('watch reload triggered', newVal, oldVal);
                if (newVal !== oldVal) {
                    this.data = this.matchdata || [];
                    this.updateFilters();
                    console.log('watch reload after updateFilters filters:', this.filters);
                    if (this.$refs.plxTable && typeof this.$refs.plxTable.reloadData === 'function') {
                        this.$refs.plxTable.reloadData(this.matchdata);
                        this.$nextTick(() => console.log('after reloadData (reload) filters:', this.filters));
                    }
                    this.emptyTxt = this.emptyText
                }
            },
            immediate: true
        },
        matchdata: {
            handler(newData, oldData) {
                console.log('watch matchdata triggered, newData length', (newData || []).length);
                this.data = newData || [];
                this.updateFilters();
                console.log('watch matchdata after updateFilters filters:', this.filters);
                if (this.$refs.plxTable && typeof this.$refs.plxTable.reloadData === 'function') {
                    this.$refs.plxTable.reloadData(this.matchdata);
                    this.$nextTick(() => console.log('after reloadData (matchdata) filters:', this.filters));
                }
                if (!newData || newData.length == 0) {
                    this.emptyTxt = '暂无数据'
                }
            },
            deep: true,
            immediate: true
        },
        emptyText(newTxt,oldTxt){
            // console.log('fdfdfd');
            if (newTxt !== oldTxt) {
                this.emptyTxt = this.emptyText
            }
        }
    },
    methods: {
        updateFilters(){
            console.log('updateFilters start, data.length', (this.data || []).length);
            const leagueSet = new Set((this.data || []).map((item) => item.league));
            this.filters = Array.from(leagueSet).map((item) => ({ label: item, value: item }));
            console.log('updateFilters end, filters count', this.filters.length, 'filters sample', this.filters.slice(0,5));
            // 尝试将 filters 应用到表格列（如果表格支持 setFilter）
            this.$nextTick(() => {
                try {
                    const grid = this.$refs.plxTable;
                    if (grid && typeof grid.getColumnByField === 'function') {
                        const column = grid.getColumnByField('league');
                        console.log('updateFilters: got column', !!column);
                        if (column && typeof grid.setFilter === 'function') {
                            grid.setFilter(column, this.filters);
                            console.log('updateFilters: called setFilter');
                            if (typeof grid.updateData === 'function') {
                                grid.updateData();
                                console.log('updateFilters: called updateData');
                            }
                        }
                    }
                } catch (e) {
                    console.warn('updateFilters apply to grid failed', e);
                }
            });
        },
        filterLeague({value, row, column}){
            // console.log('22222',{value, row, column});
            const property = column['property'];
            return row[property] === value;
        },
        removeSelected(row){
            // console.log(row);
            this.$refs.plxTable.remove(row)
        },
        saveChg(){
            const chgData = this.$refs.plxTable.getTableData().tableData;
            chgData.map(obj => {
                delete obj._XID;
                delete obj.detail;
                return obj;
            });
            // console.log(chgData);
            // const url = '/league/update-list';
            fetch(updateLeagueUrl,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(chgData)
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.msg === 'success') {
                    //弹出成功提示
                    this.$alert('更新数据成功！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }else{
                    //弹出失败提示
                    this.$alert('更新数据失败！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                }
            })
            .catch(error => {
                console.error('Error:', error);
                //弹出失败提示
                this.$alert('未知错误！更新数据失败！', '', {
                        confirmButtonText: '确定',
                });
            });
        },
        async saveChange(){
            const res = this.$refs.plxTable.getCheckboxRecords();
            console.log(res);
            if (res.length === 0) {
                console.log(0);
                this.$message({
                    showClose: true,
                    type: 'warning',
                    message: '请选中至少一条数据!'
                });
            }
            // else{
            //     // console.log(res);
            //     let countSuccess = 0;
            //     let countFail = 0;
            //     const requests = [];
            //     for (let index = 0; index < res.length; index++) {
            //         const chgData = res[index];
            //         // const url = '/league/update';
            //         const request = fetch(updateLeagueUrl,{
            //             method: 'POST',
            //             headers: {
            //                 'Content-Type': 'application/json'
            //             },
            //             body: JSON.stringify(chgData)
            //         })
            //         .then(response => response.json())
            //         .then(data => {
            //             console.log(data);
            //             if (data.msg == 'success') {
            //                 countSuccess++;
            //             }else{
            //                 countFail++;
            //             }
            //         }).catch(error => {
            //             console.error('Error:', error);
            //         });
            //         requests.push(request);        
            //     }
            //     Promise.all(requests).then(() => {
            //         this.$notify.info({
            //             title: '消息',
            //             message: `更新${countSuccess}条成功，${countFail}条失败`
            //         });
            //     }).catch(error => {
            //         console.error('Error:', error);
            //     });
            // }
        },
        // 选中的行
        selectionChange (row) {
        //   console.log(row);
          this.$emit('send-data', row)
         }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
    ::v-deep .elx-cell .col_102 {padding: 0;}
    ::v-deep .elx-cell .el-input__inner {padding: 0 5px;}
    ::v-deep .elx-cell .elx-cell--edit-icon {display: none;}
    ::v-deep .elx-cell .elx-cell--title {font-size: 12px;}
</style>